var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 49,
    viewBox: "0 0 54 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9 16.6H10.1C8.66406 16.6 7.5 17.764 7.5 19.2V45.2C7.5 46.6359 8.66406 47.8 10.1 47.8H43.9C45.3359 47.8 46.5 46.6359 46.5 45.2V19.2C46.5 17.764 45.3359 16.6 43.9 16.6Z",
    fill: "#4D8DF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1 17.6C9.21634 17.6 8.5 18.3163 8.5 19.2V45.2C8.5 46.0836 9.21634 46.8 10.1 46.8H43.9C44.7836 46.8 45.5 46.0836 45.5 45.2V19.2C45.5 18.3163 44.7836 17.6 43.9 17.6H10.1ZM6.5 19.2C6.5 17.2118 8.11177 15.6 10.1 15.6H43.9C45.8882 15.6 47.5 17.2118 47.5 19.2V45.2C47.5 47.1882 45.8882 48.8 43.9 48.8H10.1C8.11178 48.8 6.5 47.1882 6.5 45.2V19.2Z",
    fill: "#606060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8994 29.5999C19.3353 29.5999 20.4994 28.4359 20.4994 26.9999C20.4994 25.564 19.3353 24.4 17.8994 24.4C16.4634 24.4 15.2994 25.564 15.2994 26.9999C15.2994 28.4359 16.4634 29.5999 17.8994 29.5999Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 29.5999C37.5359 29.5999 38.7 28.4359 38.7 26.9999C38.7 25.564 37.5359 24.4 36.1 24.4C34.6641 24.4 33.5 25.564 33.5 26.9999C33.5 28.4359 34.6641 29.5999 36.1 29.5999Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8006 34.8C20.3646 34.8 19.2006 35.964 19.2006 37.4C19.2006 38.836 20.3646 40 21.8006 40V34.8ZM32.2006 40C33.6366 40 34.8006 38.836 34.8006 37.4C34.8006 35.964 33.6366 34.8 32.2006 34.8V40ZM21.8006 40H32.2006V34.8H21.8006V40Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 5.19991C27.5523 5.19991 28 5.64762 28 6.19991V16.5999C28 17.1522 27.5523 17.5999 27 17.5999C26.4477 17.5999 26 17.1522 26 16.5999V6.19991C26 5.64762 26.4477 5.19991 27 5.19991Z",
    fill: "#606060"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 26C1.55228 26 2 26.4477 2 27V37.4C2 37.9523 1.55228 38.4 1 38.4C0.447715 38.4 0 37.9523 0 37.4V27C0 26.4477 0.447715 26 1 26Z",
    fill: "#606060"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 26C53.5523 26 54 26.4477 54 27V37.4C54 37.9523 53.5523 38.4 53 38.4C52.4477 38.4 52 37.9523 52 37.4V27C52 26.4477 52.4477 26 53 26Z",
    fill: "#606060"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0005 1.99997C26.1169 1.99997 25.4005 2.71631 25.4005 3.59997C25.4005 4.48362 26.1169 5.19997 27.0005 5.19997C27.8842 5.19997 28.6005 4.48362 28.6005 3.59997C28.6005 2.71631 27.8842 1.99997 27.0005 1.99997ZM23.4005 3.59997C23.4005 1.61174 25.0123 -3.05176e-05 27.0005 -3.05176e-05C28.9887 -3.05176e-05 30.6005 1.61174 30.6005 3.59997C30.6005 5.58819 28.9887 7.19997 27.0005 7.19997C25.0123 7.19997 23.4005 5.58819 23.4005 3.59997Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.b47ae94d7b24add2217d0b5e9eeeb261.svg";
export { ForwardRef as ReactComponent };